<template lang="pug">
    v-card()
      //- Dialog
      v-dialog(v-model='confirmationDialog' width="500px" persistent)
        v-card(style="border: solid 1px")
          v-card-title
            | Anular {{title()}}
            v-spacer
              v-icon(aria-label="Close" @click="confirmationDialog = false")
                | mdi-close
          v-card-text.body-1.text-center
            | Esta seguro que desea anular esta {{title()}}?
          v-card-actions.text-center
            v-spacer
              v-btn(color='green darken-1', flat='', @click.native='confirmationDialog = false') No, cancelar
              v-btn(color='red darken-1', flat='', :loading="isCanceling" @click.native='cancelPurchase()') Si, proceder
      //- Content
      v-card-title.dialog-card-title
        p Detalles de {{title()}}
        v-icon(color="white" aria-label="Close" @click="$emit('close')") mdi-close
      v-card-text.request.mt-2
          h2.text-uppercase
              | Pedido #
              span(style="color: #35a3a9") {{request.reference_number}}
          h2 {{request.time | moment("h:mm:ss a, dddd, MMMM Do YYYY")}}
          h2(v-if="admin === 'transfer'") Salida:
          h2(v-if="admin === 'transfer' || admin === 'order' || admin === 'sale' || admin === 'return'") {{request.location_from.name}}
          h2(v-if="admin === 'purchase'") Proveedor {{request.provider}}
          h2(v-if="admin === 'transfer' || admin === 'purchase' || admin === 'change_inventory'") Despacho: {{request.location_to.name}}
          h2(v-if="admin === 'purchase' || admin === 'sale' || admin === 'return' || admin === 'add-inventory' || admin === 'change_inventory'") Total: {{request.total | numberFormat}}
          h2(v-if="admin === 'purchase' || admin === 'sale' || admin === 'return' || admin === 'add-inventory'") Cantidad de Productos: {{getProductsQuantity(request)}}
          p.red--text(v-if="request.isCanceled") {{title()}} anulada
          v-col(v-if="!!request.hasOwnProperty('pictures') && admin === 'purchase'").pa-0
            v-btn.ml-0(small color="primary" v-if="!!request.pictures.imageInput1" @click="showSupportImage(request.pictures.imageInput1)") ver Comprobante
          v-btn(v-if="admin === 'return' && request.status === 'pending'" color="green" small :loading="isCanceling" @click="updateReturn") Aprobar
          v-btn(v-if="!request.isCanceled && (admin === 'purchase' || admin === 'sale' || admin === 'return' || admin === 'add-inventory')" color="red" small :loading="isCanceling" @click="cancelPurchase") Anular
          v-btn(v-if="resendRequest()" color="primary" small :loading="isLoading" @click="resend(request)") Reenviar factura
          v-card(v-if="request.status === 'completed' && (admin === 'order' || admin === '')" style="border-left:4px solid green").request__sent.mt-3
              v-card-text(style=" box-shadow: -7px 4px 38px rgba(0, 0, 0, 0.16)")
                  h4.text-uppercase.green--text pedido entregado
                  p.font-weight-bold Fecha de pedido: {{request.time | moment}}
          v-layout.mt-5(v-if="admin === 'order' || admin === ''")
              v-flex(md6='')
                  h3 {{admin ? 'Detalles del cliente' : 'Tus detalles'}}
                  p Nombre: {{request.client.fullName}}
                  p(v-if="request.client.direction.direction && !admin") Dirección: {{request.client.direction.direction}}
                  p Telefono: {{request.client.phone}}
                  template(v-if="admin")
                    p(v-if="request.delivery === 'delivery'") Dirección: {{request.client.direction.direction}}
                    h3 Método de envio
                    p {{request.delivery === 'delivery' ? 'Domicilio' : 'Buscar en el establecimiento'}}
                    h3(v-if="admin === 'order' || admin === 'sale'") Método de pago
                    p(v-if="admin === 'order' || admin === 'sale'") {{request.method ? request.method : 'Efectivo'}}
              // v-flex(md6='').text-center
                  v-btn(v-if="request.status !== 'completed'" outlined rounded small color="primary") Modificar
      v-divider
      v-card-text.request
          h3.text-uppercase.grey--text Detalles de {{title()}}
          v-flex(md12='')
          v-list(two-line="")
              v-list-item-group
                  template(v-for="(item, index) in request.items")
                    v-list-item(:key="item.id" @click="showProduct(item)").request
                      template(v-slot:default="{ active, toggle }")
                        v-list-item-avatar(tile="" size="80")
                          v-img(:src='getImage(item)' contain)
                        v-list-item-content
                          p.font-weight-bold(v-if="admin !== 'expense'").product-list__title {{item.name}}
                          p.font-weight-bold(v-if="admin === 'expense'") {{item.title}}
                          p.font-weight-bold(v-if="admin === 'expense'") {{item.description}}
                          p.font-weight-bold(v-if="admin === 'expense'") {{item.typeExpense}}
                          p.font-weight-bold(v-if="item.qty || item.qty === 0" v-html="returnInventory(item)")
                          p.font-weight-bold(v-if="admin === 'transfer'") {{item.amount}}
                          p.font-weight-bold(v-else-if="admin !== 'change_inventory'")
                            | {{item.amount}} x {{item.price | numberFormat}}
                          p.font-weight-bold(v-else-if="admin === 'change_inventory'")
                            | {{item.amount - item.qty}} x {{item.price | numberFormat}}
                          p.font-weight-bold(style="color: #35a3a9" v-if="admin !== 'transfer' && admin !== 'change_inventory'") {{(parseFloat(item.amount)*parseFloat(item.price)).toFixed(2) | numberFormat}}
                          p.font-weight-bold(v-if="admin === 'sale' && item.type === 'service'") {{'comision de ' + request.user.email }}
                          p.font-weight-bold(v-if="admin === 'sale' && item.type === 'service'") {{getComissionColab(item) | numberFormat}}
                          p.font-weight-bold(v-if="!request.isCanceled && (admin === 'purchase' || admin === 'sale' || admin === 'add-inventory') && item.status" :style='item.status === "complete" ? "color: green !important":"color: #fb8c00"') {{item.status | translateStatus}}
                          p.font-weight-bold(v-if="admin === 'transfer'" :style='item.statusOrigin === "complete" && item.statusDestiny === "complete" ? "color: green !important":"color: #fb8c00"') {{item.statusOrigin === "complete" && item.statusDestiny === "complete" ? 'Completo' : 'Pendiente'}}
                  template(v-if="admin === 'return'")
                    v-form(ref="form" v-model="valid" lazy-validation)
                      v-list-item(v-for="(item, index) in request.products" :key="item.id").request
                        template(v-slot:default="{ active, toggle }")
                          v-list-item-avatar(tile="" size="80")
                            v-img(@click="showProduct(item)" :src='getImage(item)' contain)
                          v-list-item-content
                            p(@click="showProduct(item)").font-weight-bold Cantidad: {{item.qty}}
                            p(@click="showProduct(item)").font-weight-bold Referencia: {{item.name}}
                            p(@click="showProduct(item)").font-weight-bold Valor Unidad: {{item.price}}
                            p(@click="showProduct(item)").font-weight-bold Valor total: {{item.price * item.qty | numberFormat}}
                            p.font-weight-bold(v-if="item.status" :style='item.status === "complete" ? "color: green !important":"color: #fb8c00"') {{item.status | translateStatus}}
                            v-text-field(v-if="item.magnitude" label="Cantidad a inventario" type="text" v-model='item.stock'  :rules="[rules.twoDecimals]" :disabled="request.status === 'approved' || request.status === 'rejected'" @updateValue="handleStock(item, 'trash')" @keyup="handleStock(item, 'stock')" @click="handleStock(item, 'stock')")
                            v-text-field(v-if="item.magnitude" label="Cantidad a retirar" type="text" v-model='item.trash'  :rules="[rules.twoDecimals]" :disabled="request.status === 'approved' || request.status === 'rejected'" @updateValue="handleStock(item, 'trash')" @keyup="handleStock(item, 'trash')" @click="handleStock(item, 'trash')")
                            v-text-field(v-if="!item.magnitude" label="Cantidad a inventario" type="number" v-model='item.stock'  :rules="[rules.required]" :disabled="request.status === 'approved' || request.status === 'rejected'" @updateValue="handleStock(item, 'trash')" @keyup="handleStock(item, 'stock')" @click="handleStock(item, 'stock')" min="0" :max="item.qty")
                            v-text-field(v-if="!item.magnitude" label="Cantidad a retirar" type="number" v-model='item.trash'  :rules="[rules.required]" :disabled="request.status === 'approved' || request.status === 'rejected'" @updateValue="handleStock(item, 'trash')" @keyup="handleStock(item, 'trash')" @click="handleStock(item, 'trash')" min="0" :max="item.qty")
                  v-list-item(v-if="admin === 'expense'").request
                    v-list-item-content
                      table()
                        tr
                          th Razón
                          th Descripción
                          th Monto
                          th tipo
                        tr.pt-5
                          td(style="max-width:100px;") {{request.title | shortName}}
                          td(style="max-width:100px;") {{request.description | shortName}}
                          td {{request.typeExpense}}
                          td {{request.amount}}
</template>

<script>
  import moment from 'moment'
  import productPlaceHolder from '@/assets/icons/products.png'
  import Swal from 'sweetalert2'

  export default {
    filters: {
      shortName (val) {
        if (val.length > 50) {
          return val.substring(0, 50) + '...'
        } else {
          return val
        }
      },
      moment: function (date) {
        return moment(date).format('DD/MM/YYYY')
      },
      numberFormat (val) {
        if (val) { return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
      translateStatus (value) {
        if (value) {
          switch (value) {
            case 'pending':
              return 'Pendiente'
            case 'complete':
              return 'Completo'
          }
        } else {
          return 'N/A'
        }
      },
    },
    components: {
      productPlaceHolder: productPlaceHolder,
    },
    props: {
      admin: {
        default: '',
        type: String,
      },
      request: {
        type: Object,
        default: function () {
          return {}
        },
      },
    },
    data () {
      return {
        valid: false,
        rules: {
          required: value => ((/^[0-9]*$/.test(value)) && value !== '') || 'El campo es requerido.',
          twoDecimals: value => (/^[0-9]+(\.[0-9]{1,2})?$/.test(value) && value !== '') || 'El campo es requerido. Solo dos decimales permitidos',
        },
        isCanceling: false,
        confirmationDialog: false,
        resendPurchase: false,
      }
    },
    computed: {
      inventory () {
        return this.$store.getters['products/getAllItems']
      },
      isLoading () {
        return this.$store.getters['transactions/getLoading']
      },
    },
    mounted () {
      const vm = this
      // console.log(vm.request, vm.admin, 'request')
      if (vm.admin === 'purchase' || vm.admin === 'sale' || vm.admin === 'add-inventory') {
        const found = vm.request.items.find(element => element.status === 'pending')
        // console.log(found)
        if (found) {
          vm.resendPurchase = true
        }
      } else if (vm.admin === 'transfer') {
        const found = vm.request.items.find(element => element.statusOrigin === 'pending' || element.statusDestiny === 'pending')
        // console.log(found)
        if (found) {
          vm.resendPurchase = true
        }
      } else if (vm.admin === 'return') {
        const found = vm.request.products.find(element => element.status === 'pending')
        // console.log(found)
        if (found) {
          vm.resendPurchase = true
        }
      }
    },
    methods: {
      getComissionColab (item) {
        const price = item.price
        if (item.comissionColab) {
          if (item.comissionColab.percentage) {
            return ((+price * (+item.comissionColab.price / 100).toFixed(2)).toFixed(2))
          } else {
            return +item.comissionColab.price
          }
        } else {
          return 0
        }
      },
      handleStock (val, type) {
        // console.log(val)
        if (val.magnitude) {
          if (typeof val.trash === 'string') {
            val.trash = parseFloat(val.trash.replace(',', '.'))
          }
          if (typeof val.qty === 'string') {
            val.qty = parseFloat(val.qty.replace(',', '.'))
          }
          if (typeof val.stock === 'string') {
            val.stock = parseFloat(val.stock.replace(',', '.'))
          }
        }
        const trash = !val.magnitude ? parseInt(val.trash) : parseFloat(val.trash)
        const qty = !val.magnitude ? parseInt(val.qty) : parseFloat(val.qty)
        const stock = !val.magnitude ? parseInt(val.stock) : parseFloat(val.stock)
        if (!Number.isNaN(trash) && !Number.isNaN(qty) && !Number.isNaN(stock)) {
          if (type === 'stock') {
            let value
            if (val.magnitude) {
              value = (qty - stock).toFixed(2)
            } else {
              value = qty - stock
            }
            // console.log(qty, stock, value)
            if (((!val.magnitude && Number.isInteger(value)) || val.magnitude) && value >= 0 && stock >= 0) {
              val.stock = stock
              val.trash = value
            } else {
              val.stock = qty
              val.trash = 0
            }
          } else {
            let value
            if (val.magnitude) {
              value = (qty - stock).toFixed(2)
            } else {
              value = qty - stock
            }
            if (((!val.magnitude && Number.isInteger(value)) || val.magnitude) && value >= 0 && trash >= 0) {
              val.trash = trash
              val.stock = value
            } else {
              val.trash = qty
              val.stock = 0
            }
          }
        } else {
          val.stock = 0
          val.trash = qty
        }
      },
      updateReturn () {
        if (this.$refs.form.validate()) {
          const vm = this
          vm.request.products.forEach(element => {
            element.status = 'pending'
          })
          vm.$store.dispatch('transactions/updateReturn', vm.request).then(function () {
            Swal.fire({
              icon: 'success',
              title: 'Tu devolución ha sido aprobada con exito',
            })
            vm.$emit('close')
          })
        }
      },
      async cancelPurchase () {
        const vm = this
        const data = {
          item: vm.request,
          type: vm.admin + 's',
        }
        let titleSwal
        let question
        if (vm.admin === 'purchase') {
          titleSwal = 'Anular factura de compra'
          question = 'Estas seguro que deseas anular esta compra?'
        } else if (vm.admin === 'sale') {
          titleSwal = 'Anular venta'
          question = 'Estas seguro que deseas anular esta factura?'
        } else if (vm.admin === 'return') {
          titleSwal = 'Anular devolución'
          question = 'Estas seguro que deseas anular esta devolucion?'
        } else if (vm.admin === 'add-inventory') {
          titleSwal = 'Anular factura de inventario'
          question = 'Estas seguro que deseas anular esta factura de inventario?'
        }

        if (data.type === 'purchases') {
          const prodsWithZeroStock = []
          for await (const item of data.item.items) {
            const itemInv = vm.inventory.find(el => el.id === item.id)
            if (itemInv && parseFloat(itemInv.location[data.item.location_to.id].stock) < parseFloat(item.amount)) {
              prodsWithZeroStock.push(item.name + ',')
            }
          }
          if (prodsWithZeroStock.length > 0) {
            titleSwal = 'Los siguientes productos tienen menos stock del que se quiere devolver: '
            prodsWithZeroStock.forEach(element => {
              titleSwal += element
            })
            titleSwal += ' Estos productos quedaran con stock 0.' + question
          }
        }
        Swal.fire({
          title: titleSwal,
          text: '¿' + question,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, anular',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.value) {
            vm.isCanceling = true
            vm.$store.dispatch('transactions/cancelItem', data).then(function () {
              vm.isCanceling = false
              vm.request.isCanceled = true
              vm.confirmationDialog = false
              vm.request.status = 'rejected'
              Swal.fire({
                icon: 'success',
                title: `Tu ${vm.title()} ha sido anulada con exito`,
              })
            })
          }
        })
      },
      showSupportImage (item) {
        this.$emit('showSupportImage', item)
      },
      getImage (item) {
        // console.log(item)
        if (item.pictures && item.pictures.imageInput1) {
          return item.pictures.imageInput1
        } else {
          return productPlaceHolder
        }
      },
      showProduct (item) {
        const vm = this
        vm.$store.dispatch('products/setCurrentItem', item).then(function () {
          vm.$emit('showProduct')
        })
      },
      title () {
        switch (this.admin) {
          case '':
            return 'pedido'
          case 'sale':
            return 'venta'
          case 'purchase':
            return 'compra'
          case 'expense':
            return 'gasto'
          case 'return':
            return 'devolución'
          case 'transfer':
            return 'traslado'
          case 'order':
            return 'orden'
          case 'add-inventory':
            return 'Agregar inventario'
          case 'change_inventory':
            return 'cambio de inventario'
        }
      },
      resend (item) {
        const vm = this
        let title = ''
        let description = ''
        if (item.type === 'purchases') {
          title = 'Reenviar factura de compra'
          description = 'Al reenviar la factura de compra los productos se agregarán a su inventario. ¿Desea continuar?'
        } else if (item.type === 'sales') {
          title = 'Reenviar factura de venta'
          description = 'Al reenviar la factura de compra los productos se restarán a su inventario. ¿Desea continuar?'
        } else if (item.type === 'transfers') {
          title = 'Reenviar transferencia'
          description = 'Al reenviar la transferencia los productos se restarán al origen o se agregarán al destino. ¿Desea continuar?'
        } else if (item.type === 'returns') {
          title = 'Reenviar devolución'
          description = 'Al reenviar la devolución los productos se agregarán a su inventario. ¿Desea continuar?'
        } else if (item.type === 'add-inventory') {
          title = 'Reenviar factura de inventario'
          description = 'Al reenviar la factura de inventario los productos se agregarán a su inventario. ¿Desea continuar?'
        }
        vm.$swal({
          icon: 'error',
          title: title,
          text: description,
          showCancelButton: true,
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.value) {
            vm.$store.dispatch('transactions/resendPurchase', item).then((response) => {
              vm.$swal({
                icon: 'success',
                title: 'Proceso exitoso',
                text: `Se ${description} los productos a su inventario!`,
              })
              vm.$emit('close')
            })
          }
        })
      },
      resendRequest () {
        const vm = this
        if (!vm.request.isCanceled && (vm.admin === 'purchase' || vm.admin === 'sale' || vm.admin === 'transfer' || vm.admin === 'return' || vm.admin === 'add-inventory') && vm.resendPurchase && moment(vm.request.time).add(1, 'minutes').isBefore(moment())) {
          return true
        } else {
          return false
        }
      },
      getProductsQuantity (transaction) {
        const vm = this
        let productQuantity = 0
        if (vm.admin === 'return') {
          transaction.products.forEach(item => {
            productQuantity += parseFloat(item.qty)
          })
        } else {
          transaction.items.forEach(item => {
            productQuantity += parseFloat(item.amount)
          })
        }
        return productQuantity
      },
      returnInventory (item) {
        const vm = this
        if (vm.admin === 'sale') return `Inventario: (${item.qty}) &#8594 ${+item.qty - +item.amount}`
        if (vm.admin === 'change_inventory') return `Inventario: (${item.qty}) &#8594 ${+item.amount}`
        return `Inventario: (${item.qty}) &#8594 (${+item.qty + +item.amount})`
      },
    },
  }
</script>

<style lang='scss' scoped>
// .request{
//   display: flex;
//   width: 95%;
//   margin: 0 auto;
//   // border-radius: 10px !important;
//   box-shadow: -7px 4px 38px rgba(0, 0, 0, 0.16);
//   &__container{
//     @media (max-width: 1024px){
//       background: transparent;
//     }
//   }
//   &__title{
//     color: #35a3a9 !important;
//   }
//   &__sent{
//     border-left: 4px solid #fb8c00;
//     font-weight: bold;
//   }
//   &__complete{
//     border-left: 4px solid green;
//     font-weight: bold;
//   }
//   &__date{
//     font-size: 13px;
//     color: #808184;
//   }
//   &__price{
//     color: #35a3a9 !important;
//   }
//   &__description{
//     color: #808184;
//     font-size: 18px;
//     font-weight: 300;
//     line-height: 1.2;
//   }
// }
.product-list__title {
  max-width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
